import React from 'react';
import Button from '../common/Button';

const AdminHeader = ({ title, description, showBackButton = true, children }) => {
  return (
    <div className="mb-8">
      {showBackButton && (
        <Button
          onClick={() => window.location.href = '/admin'}
          variant="outline"
          size="small"
          className="mb-4"
        >
          ← Back to Admin
        </Button>
      )}
      <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
      {description && (
        <p className="mt-1 text-sm text-gray-600">
          {description}
        </p>
      )}
      {children}
    </div>
  );
};

export default AdminHeader;
